import React, { useEffect, useState } from 'react'
import "./core-tooltip.css"
import { TextHtmlTagType } from '../../../../misc/tools';

const CoreTooltip = (props: CoreTooltipConfig) => {
	const [isVisible, setIsVisible] = useState(false);
	const [isInitialized, setIsInitialized] = useState(false);
	const [element, setElement] = useState(null);
	const [positionY, setPositionY] = useState(0);


	useEffect(() => {
		const onElementHover = () => {
			setIsVisible(true);
		}

		const onElementLeave = () => {
			setIsVisible(false);
		}
		
		if(!isInitialized) {
			const $element = $('#' + props.hoverParentElementId);
			setElement($element);
			setPositionY($element.height() + 25);
			$element.on('mouseover', onElementHover);
			$element.on('mouseout', onElementLeave);
			setIsInitialized(true);
		}

		return () => {
			element?.off('mouseover', onElementHover);
			element?.off('mouseout', onElementLeave);
		}
	}, [])
	if(!isVisible) {
		return (null);
	}
	return (
		<div className="core-tooltip-root modal-disable-select" style={{
			top: positionY
		}}>
			<p className=''>{props.text}</p>
		</div>
	);

};

export interface CoreTooltipConfig {
	hoverParentElementId: string;
	text: string;
}

export default CoreTooltip;